// hooks/useUserLocaleChoice.ts
import { useState, useEffect } from 'react';

interface UserLocaleChoice {
  locale: string;
  currency: string;
  country: string;
}

const defaultUserChoice: UserLocaleChoice = {
  locale: 'ar',
  currency: 'ILS',
  country: 'Israel'
};

export function useUserLocaleChoice() {
  const [userSavedChoice, setUserSavedChoice] = useState<UserLocaleChoice>(defaultUserChoice);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    const stored = localStorage.getItem('user-locale-choice');
    if (stored) {
      try {
        setUserSavedChoice(JSON.parse(stored));
      } catch (error) {
        console.error('Error parsing user locale choice:', error);
      }
    }
  }, []);

  return { userSavedChoice, isClient };
}